export default [
  {
    path: '/players/rating',
    name: 'players-rating',
    component: () => import('@/views/players/PlayersRating.vue'),
    meta: {
      pageTitle: 'Рейтинг игроков',
      breadcrumb: [
        { text: 'Игроки', active: true },
        { text: 'Рейтинг', active: true },
      ],
      resource: 'players',
      action: 'view',
    },
  },
]
